<template>
  <div v-if="loaded">
    <div class="w-100 text-left">
      <mdb-btn
        size="sm"
        gradient="aqua"
        rounded
        icon="arrow-left"
        @click="$emit('back')"
      >Back to Calendar</mdb-btn>
    </div>
    <div class="d-flex flex-row justify-content-between w-100 mt-4">
      <bridge8-select-list
        :options="rules"
        null-value-string="Create new Rule..."
        entity="rule"
        label="Select Rule"
        :text-callback="obj => obj.name"
        :search="true"
        :value="null"
        @selected="ruleSelected($event)"
      />
      <div class="w-75 h-75 text-left">
        <mdb-stepper
          @submit="submit()"
          simpleH
          :steps="steps"
          buttons
          class="m-4"
          :options="{
            stepBtn: {
              outline: 'cyan',
              active: 'success',
              iconClass: 'text-dark'
            },
            nextBtn: {
              color: 'cyan',
              text: 'Next'
            },
            prevBtn: {
              color: 'cyan',
              text: 'Previous'
            },
            submitBtn: {
              color: 'success',
              text: 'Submit'
            },
            lineColor: 'cyan'
          }"
        >
          <template :slot="1">
            <mdb-card narrow>
              <div
                class="
                  pb-2
                  pt-4
                  view
                  view-cascade
                  gradient-card-header
                  aqua-gradient
                  text-dark
                  narrower
                "
              >
                <h4>General</h4>
              </div>
              <mdb-container>
                <mdb-row>
                  <mdb-col col="6">
                    <mdb-input
                      outline
                      label="Name"
                      v-model="rule.name"
                    />
                    <mdb-input
                      outline
                      label="Code"
                      v-model="rule.code"
                    />
                    <mdb-select
                      outline
                      search
                      label="Event Type"
                      v-model="eventTypeModel"
                      @getValue="setEventType($event)"
                    />
                    <mdb-select
                      outline
                      search
                      label="Event Status"
                      v-model="eventStatusModel"
                      @getValue="setEventStatus($event)"
                    />
                  </mdb-col>
                  <mdb-col col="6">
                    <ul
                      class="list-unstyled mt-3"
                      v-if="
                        rule
                        && rule.eventActions
                        && rule.eventActions.length > 0
                        && modelLoading.length === 0
                      "
                    >
                      <li
                        class="border-bottom mb-2s"
                        v-for="(data, actionIndex) in (rule ? rule.eventActions : [])"
                        :key="`actions-list-${actionIndex}-item`
                      ">
                        <span>{{ data.action.name }}</span>
                        <mdb-icon
                          class="text-danger ml-3 ho"
                          icon="times"
                          title="Delete Action"
                          :style="{cursor: 'pointer'}"
                          @click.native="deleteEventAction(actionIndex)"
                        />
                      </li>
                    </ul>
                    <mdb-select
                      outline
                      search
                      label="New Event Action"
                      v-model="eventActionModel"
                      @getValue="addEventAction($event)"
                    />
                  </mdb-col>
                </mdb-row>
              </mdb-container>
            </mdb-card>
          </template>
          <template
            v-if="
              rule
              && rule.eventActions
              && rule.eventActions.length > 0
              && modelLoading.length === 0
            "
            v-for="(data, actionIndex) in (rule ? rule.eventActions : [])"
            :slot="actionIndex + 2"
          >
            <mdb-card :key="`event-action-${actionIndex}`" narrow>
              <div
                class="
                  pb-2
                  pt-4
                  view
                  view-cascade
                  gradient-card-header
                  aqua-gradient
                  text-dark
                  narrower
                "
              >
                <h4>{{ data.action.description }}</h4>
              </div>
              <mdb-card-body>
                <template v-for="(prop, propIndex) in data.action.properties">
                  <div :key="`event-action-${actionIndex}-prop-${propIndex}`">
                    <small v-html="prop.description"></small>
                    <mdb-select
                      v-if="!!prop.entity"
                      outline
                      search
                      :label="prop.name"
                      v-model="model[actionIndex][propIndex]"
                    />
                    <mdb-input
                      v-else
                      outline
                      :label="prop.name"
                      v-model="model[actionIndex][propIndex]"
                    />
                    <hr class="p-0 m-o"/>
                  </div>
                </template>
              </mdb-card-body>
            </mdb-card>
          </template>
          <template :slot="(rule ? rule.eventActions : []).length + 2"/>
        </mdb-stepper>
      </div>
    </div>
  </div>
</template>

<script>
import Bridge8SelectList from './Bridge8SelectList'
import {
  mdbBtn,
  mdbStepper,
  mdbContainer,
  mdbRow,
  mdbCol,
  mdbCard,
  mdbCardHeader,
  mdbCardBody,
  mdbInput,
  mdbSelect,
  mdbIcon
} from 'mdbvue'
import {mapActions} from 'vuex'
import {errorCatch} from '../utils'

export default {
  name: 'CalendarBusinessProcesses',
  data () {
    return {
      loaded: false,
      emptyRule: {name: null, eventStatus: null, eventType: null, code: null, eventActions: []},
      rule: {name: null, eventStatus: null, eventType: null, code: null, eventActions: []},
      rules: [],
      entities: {},
      eventTypeModel: [],
      eventStatusModel: [],
      eventActionModel: [],
      model: {},
      modelLoading: []
    }
  },
  computed: {
    steps () {
      return [
        {name: 'General'},
        ...(this.rule ? this.rule.eventActions.map(ea => {
          return {name: ea.action.name}
        }) : []),
        {name: 'Submit'}
      ]
    }
  },
  methods: {
    ...mapActions([
      'apiGetEventStatusChangeRules',
      'apiGetEntitiesCodeName',
      'apiGetEventAction',
      'apiChangeEventStatusChangeRule'
    ]),
    ruleSelected (rule) {
      this.rule = rule || this.emptyRule
    },
    setEventStatus (es) {
      if (this.rule) {
        this.rule.eventStatus = es
      }
    },
    setEventType (et) {
      if (this.rule) {
        this.rule.eventType = et
      }
    },
    addEventAction (actionCode) {
      if (actionCode === null) {
        return
      }
      this.apiGetEventAction(actionCode)
        .then(action => {
          this.modelLoading.push(true)
          const actionIndex = Object.keys(this.model).length
          const parameters = {}
          action.properties.forEach(prop => {
            parameters[prop.code] = null
          })
          this.$set(
            this.rule.eventActions,
            actionIndex,
            {
              action: action,
              parameters: parameters
            }
          )
          action.properties.forEach((prop, propIndex) => {
            this.modelLoading.push(true)
            const promise = !prop.entity || this.entities[prop.entity]
              ? new Promise((resolve, reject) => { resolve() })
              : this.apiGetEntitiesCodeName(prop.entity)
                .then(data => {
                  console.log(this.entities, prop.entity, data)
                  this.entities[prop.entity] = data
                })
            promise.then(() => {
              if (!this.model[actionIndex]) {
                this.$set(this.model, actionIndex, {})
              }
              this.$set(this.model[actionIndex], propIndex, (
                prop.entity
                  ? this.entities[prop.entity].map(e => {
                    return {
                      text: e.name,
                      value: e.code,
                      selected: false
                    }
                  })
                  : null
              ))
              this.modelLoading.pop()
            })
          })
          this.modelLoading.pop()
        })
        .catch(errorCatch('Get Event Action failed', this))
    },
    deleteEventAction (index) {
      this.$delete(this.model, index)
      this.$delete(this.rule.eventActions, index)
    },
    submit () {
      const rule = Object.assign({}, this.rule)
      rule.eventStatus = this.eventStatusModel.find(esm => esm.selected).value
      rule.eventType = this.eventTypeModel.find(etm => etm.selected).value
      const eas = []
      rule.eventActions.forEach((actionInfo, actionIndex) => {
        if (!eas[actionIndex]) {
          eas[actionIndex] = {code: actionInfo.action.code, properties: {}}
        }
        actionInfo.action.properties.forEach((prop, propIndex) => {
          eas[actionIndex].properties[prop.code] = Array.isArray(this.model[actionIndex][propIndex])
            ? this.model[actionIndex][propIndex].find(x => x.selected).value : this.model[actionIndex][propIndex]
        })
      })
      rule.eventActions = eas
      this.apiChangeEventStatusChangeRule(rule)
        .catch(errorCatch('Change Event Status Change Rule failed', this))
    }
  },
  mounted () {
    this.apiGetEventStatusChangeRules()
      .then(rules => {
        this.rules = rules
      })
      .catch(errorCatch('Get EventStatusChangeRules failed', this))
    this.ruleSelected(null)
    this.loaded = true
  },
  watch: {
    rule: {
      deep: true,
      handler: function () {
        console.log('Watch')
        this.modelLoading.push(true);
        [
          'Event Status',
          'Event Type',
          'Event Action'
        ].forEach(entity => {
          this.modelLoading.push(true)
          const modelName = entity.replace(/^Event\s/, 'event')
          const entityName = entity.replace(/^Event\s/, 'Event')
          const promise = this.entities[entityName]
            ? new Promise((resolve, reject) => { resolve() })
            : this.apiGetEntitiesCodeName(entityName)
              .then(data => {
                this.entities[entityName] = data
              })
          promise.then(() => {
            this[modelName + 'Model'] =
              this.entities[entityName].map(e => {
                return {
                  text: e.name,
                  value: e.code,
                  selected: (!!this.rule[modelName]) && (this.rule[modelName] === e.code)
                }
              })
            this.modelLoading.pop()
          })
        })
        this.model = {}
        if (this.rule && this.rule.eventActions && this.rule.eventActions.length > 0) {
          this.rule.eventActions.forEach((eventAction, eventActionIndex) => {
            if (!this.model[eventActionIndex]) {
              this.$set(this.model, eventActionIndex, {})
            }
            eventAction.action.properties.forEach((prop, propIndex) => {
              this.modelLoading.push(true)
              const promise = !prop.entity || this.entities[prop.entity]
                ? new Promise((resolve, reject) => { resolve() })
                : this.apiGetEntitiesCodeName(prop.entity)
                  .then(data => {
                    this.entities[prop.entity] = data
                  })
              promise.then(() => {
                this.$set(
                  this.model[eventActionIndex],
                  propIndex,
                  prop.entity
                    ? this.entities[prop.entity].map(e => {
                      return {
                        text: e.name,
                        value: e.code,
                        selected: e.code === eventAction.parameters[prop.code]
                      }
                    })
                    : eventAction.parameters[prop.code]
                )
                this.modelLoading.pop()
              })
            })
          })
        }
        this.modelLoading.pop()
      }
    }
  },
  components: {
    mdbBtn,
    mdbStepper,
    mdbContainer,
    mdbCard,
    mdbCardHeader,
    mdbCardBody,
    mdbRow,
    mdbCol,
    mdbInput,
    mdbSelect,
    Bridge8SelectList,
    mdbIcon
  }
}
</script>

<style lang="sass">
.step.active
  overflow: visible!important
</style>



// WEBPACK FOOTER //
// src/components/CalendarBusinessProcesses.vue